// Lang convertor for testing: http://www.pseudolocalize.com/

import english from './LanguageData/english'
import spanish from './LanguageData/spanish'

const defaultLang = 'en'
const allowedLanguages = ['en', 'es']

let lang = localStorage.getItem('lang')
const isLangValid = allowedLanguages.includes(lang)
if (!isLangValid) {
  lang = defaultLang
}

const languageMapper = {
  en: english,
  es: spanish,
}

const setLanguage = (newLanguage) => {
  localStorage.setItem('lang', newLanguage)
}

export default languageMapper[lang]

export { defaultLang, allowedLanguages, setLanguage }
